import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AudioMutedOutlinedSvg from "@ant-design/icons-svg/es/asn/AudioMutedOutlined";
import AntdIcon from "../components/AntdIcon";
var AudioMutedOutlined = function AudioMutedOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AudioMutedOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  AudioMutedOutlined.displayName = 'AudioMutedOutlined';
}
export default /*#__PURE__*/React.forwardRef(AudioMutedOutlined);